import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import IconRewardHover from '@/components/common/IconRewardHover/IconRewardHover';
import type { useVaultV2RecapFormatting } from './hooks/useVaultV2RecapFormatting';
interface RecapApyRowProps {
  asset: InterfaceToken;
  formatting: ReturnType<typeof useVaultV2RecapFormatting>;
}

/** The vault recaps' APY row, backed by the rewards hover card. */
const RecapApyRow = t0 => {
  const $ = _c(21);
  const {
    asset,
    formatting
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-secondary-foreground text-xs">APY</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== asset || $[2] !== formatting.apy || $[3] !== formatting.includesDonations || $[4] !== formatting.isRateCapped || $[5] !== formatting.managementFee || $[6] !== formatting.maxApy || $[7] !== formatting.maxRate || $[8] !== formatting.netApy || $[9] !== formatting.performanceFee || $[10] !== formatting.points || $[11] !== formatting.rewards) {
    t2 = {
      performanceFee: formatting.performanceFee,
      managementFee: formatting.managementFee,
      apy: formatting.apy,
      variant: "vault",
      asset,
      netApy: formatting.netApy,
      points: formatting.points,
      rewards: formatting.rewards,
      maxRate: formatting.maxRate,
      maxApy: formatting.maxApy,
      isRateCapped: formatting.isRateCapped,
      includesDonations: formatting.includesDonations
    };
    $[1] = asset;
    $[2] = formatting.apy;
    $[3] = formatting.includesDonations;
    $[4] = formatting.isRateCapped;
    $[5] = formatting.managementFee;
    $[6] = formatting.maxApy;
    $[7] = formatting.maxRate;
    $[8] = formatting.netApy;
    $[9] = formatting.performanceFee;
    $[10] = formatting.points;
    $[11] = formatting.rewards;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== formatting.vaultV2) {
    t3 = formatting.vaultV2 ? {
      chainId: formatting.vaultV2.asset.chain.id,
      address: formatting.vaultV2.address
    } : undefined;
    $[13] = formatting.vaultV2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== formatting.formattedNetApy) {
    t4 = <span className="text-foreground text-xs">{formatting.formattedNetApy}</span>;
    $[15] = formatting.formattedNetApy;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = <div className="flex items-center justify-between gap-[16px]">{t1}<IconRewardHover RewardsHoverCardProps={t2} vaultV2ApyInput={t3}>{t4}</IconRewardHover></div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default RecapApyRow;